<!-- Button: avatar + chevron share one menu trigger so the whole control is clickable -->
<div class="flex items-center">
  <button
    #menuTrigger="matMenuTrigger"
    aria-label="User menu"
    class="inline-flex cursor-pointer items-center gap-2 rounded-full border-0 bg-transparent p-1 text-inherit focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
    type="button"
    [matMenuTriggerFor]="userActions"
  >
    <span class="relative flex items-center gap-2">
      <div class="flex h-8 w-8 items-center justify-center rounded-full bg-primary text-sm font-semibold text-white">
        {{ usernameAbbreviation }}
      </div>
      <mat-icon
        class="text-gray-400 icon-size-4"
        [svgIcon]="menuTrigger.menuOpen ? 'heroicons_outline:chevron-up' : 'heroicons_outline:chevron-down'"
      />
    </span>
  </button>
</div>

<mat-menu #userActions="matMenu" class="user-actions-menu mt-3" [xPosition]="'before'">
  <button class="group hover:bg-primary hover:text-white" mat-menu-item (click)="profile()">
    <mat-icon class="group-hover:text-white" [svgIcon]="'heroicons_outline:user-circle'" />
    <span>Profile</span>
  </button>
  <button class="group hover:bg-primary hover:text-white" mat-menu-item (click)="signOut()">
    <mat-icon class="group-hover:text-white" [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'" />
    <span>Sign out</span>
  </button>
</mat-menu>

<mat-menu #userStatus="matMenu" class="user-status-menu">
  <button mat-menu-item (click)="updateUserStatus('online')">
    <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-green-500"></span>
    <span>Online</span>
  </button>
  <button mat-menu-item (click)="updateUserStatus('away')">
    <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-amber-500"></span>
    <span>Away</span>
  </button>
  <button mat-menu-item (click)="updateUserStatus('busy')">
    <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-red-500"></span>
    <span>Busy</span>
  </button>
  <button mat-menu-item (click)="updateUserStatus('not-visible')">
    <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-gray-400"></span>
    <span>Invisible</span>
  </button>
</mat-menu>
